// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollContainer {
  width: 50%;
  height: 100px;
  overflow: scroll;
  border: 1px solid #444;
  margin: 0 auto;
}
.tooltip {
  max-width: 600px;
  word-wrap: break-word;
}

.tooltipDivContainer {
  width: 100%;
  height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/examples/auxiliary/tooltip/tooltip-resize-behavior/styles.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;AACf","sourcesContent":[".scrollContainer {\n  width: 50%;\n  height: 100px;\n  overflow: scroll;\n  border: 1px solid #444;\n  margin: 0 auto;\n}\n.tooltip {\n  max-width: 600px;\n  word-wrap: break-word;\n}\n\n.tooltipDivContainer {\n  width: 100%;\n  height: 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollContainer": `scrollContainer`,
	"tooltip": `tooltip`,
	"tooltipDivContainer": `tooltipDivContainer`
};
export default ___CSS_LOADER_EXPORT___;
